import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from "react";
import states from "@oui/lib/src/metadata/states.json";
import { AddressInputSchema } from "@oui/lib/src/types";
import { Label, Text } from "../Text";
import { View } from "../View";
import { PickerFormInput, TextFormInput, useSubFormContext } from "../../form";
import { useWindowDimensions } from "../../hooks/useWindowDimensions";
import { useTheme } from "../../styles";
/**
 * Fields for filling out an address inside a form
 *
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̅̀̀̃̀̀̀̂̌̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̃̈̀̀̃̂̀̀̃́̀̀̃̉̀̀̆̅̀̀̆̄̀̀̃̀̀̀̆̅̀̀̂̍̀̀̆́̀̀̃́̀̀̃̃̀̀̆̃̀̀̂̍̀̀̃̄̀̀̆̅̀̀̃̅̀̀̃̃̀̀̂̍̀̀̃̈̀̀̆́̀̀̃̄̀̀̃̈̀̀̂̍̀̀̃̂̀̀̆̆̀̀̆̆̀̀̃́̀̀̃̉̀̀̆̅̀̀̃̈̀̀̆̃̀̀̆̆̀̀̃̅̀̀̃̅̀̀̃̀̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̅̀̀̃̂̀̀̃̂̀̀̂̍̀̀̃̂̀̀̃́̀̀̃́̀̀̃́̀̀̃̂̀̀̃̃̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃̄̀̀̃̉̀̀̃̉̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̈̀̀̃̂̀̀̃́̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-1}
 */ export function AddressFormInput(param) {
    var name = param.name, control = param.control, requiresMailingAddress = param.requiresMailingAddress;
    var _useSubFormContext = useSubFormContext(AddressInputSchema, control, name), getName = _useSubFormContext.getName, setValue = _useSubFormContext.setValue, watch = _useSubFormContext.watch;
    var width = useWindowDimensions().width;
    var theme = useTheme().theme;
    var addressValue = watch();
    useEffect(function() {
        // ensure rank/use are always specified
        if ((addressValue === null || addressValue === void 0 ? void 0 : addressValue.rank) == null) setValue('rank', 0);
        if (!(addressValue === null || addressValue === void 0 ? void 0 : addressValue.use)) setValue('use', 'HOME');
    }, [
        setValue,
        addressValue
    ]);
    return /*#__PURE__*/ _jsxs(View, {
        testID: "AddressFormInput",
        style: {
            gap: 10
        },
        children: [
            /*#__PURE__*/ _jsx(Label, {
                style: {
                    marginLeft: 16
                },
                testID: "AddressFormInput_label",
                text: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        "Mailing address",
                        requiresMailingAddress ? /*#__PURE__*/ _jsx(Text, {
                            text: " *",
                            color: theme.color.danger,
                            weight: "semibold"
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(TextFormInput, {
                control: control,
                name: getName('line.0'),
                required: requiresMailingAddress,
                "aria-label": "Street address",
                placeholder: "Street address"
            }),
            /*#__PURE__*/ _jsx(TextFormInput, {
                control: control,
                name: getName('line.1'),
                "aria-label": "Address Line 2",
                placeholder: "Address Line 2"
            }),
            /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    gap: 10,
                    flexWrap: 'wrap'
                },
                children: [
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            flex: 1,
                            flexBasis: width < 600 ? '100%' : undefined
                        },
                        children: /*#__PURE__*/ _jsx(TextFormInput, {
                            control: control,
                            name: getName('city'),
                            required: requiresMailingAddress,
                            "aria-label": "City",
                            placeholder: "City"
                        })
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            flex: 1
                        },
                        children: /*#__PURE__*/ _jsx(PickerFormInput, {
                            control: control,
                            name: getName('state'),
                            items: states.map(function(s) {
                                return {
                                    label: s.name,
                                    value: s.abbreviation
                                };
                            }),
                            required: requiresMailingAddress,
                            "aria-label": "State",
                            placeholder: "State"
                        })
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: {
                            flex: 1
                        },
                        children: /*#__PURE__*/ _jsx(TextFormInput, {
                            control: control,
                            name: getName('postalCode'),
                            required: requiresMailingAddress,
                            "aria-label": "ZIP code",
                            placeholder: "ZIP Code"
                        })
                    })
                ]
            })
        ]
    });
}
